import { takeLatest, all, takeEvery } from "redux-saga/effects";
import * as authSagas from "../modules/login/redux/sagas/handleAuth";
import * as authConstants from "../modules/login/redux/constants";
import * as constants from "../modules/UserManager/redux/constants";
import * as usersManager from "../modules/UserManager/redux/sagas/handleUserManager";
import * as departmentsConstants from "../modules/ActivityTypes/redux/constants";
import * as departments from "../modules/ActivityTypes/redux/sagas/handleActivityTypes";
import * as prodStatuses from "../modules/ProjectStatuses/redux/sagas/handleActivityTypes";
import * as prodStatusesConstants from "../modules/ProjectStatuses/redux/constants";
import * as commodityConstants from "../modules/commodity/redux/constants";
import * as commodity from "../modules/commodity/redux/sagas/handlecommodityTypes";
import * as supplierConstants from "../modules/supplier/redux/constants";
import * as supplier from "../modules/supplier/redux/sagas/handleSupplierTypes";
import * as materialTypesConstants from "../modules/materialTypes/redux/constants";
import * as materialTypes from "../modules/materialTypes/redux/sagas/handleMaterialTypes";
import * as locationConstants from "../modules/LocationManager/redux/constants";
import * as locationSagas from "../modules/LocationManager/redux/sagas/handleLocationsManager";
import * as projectSetupSagas from "../modules/ProjectSetup/redux/sagas/handleProjectsSetupManager";
import * as projectSetupConstants from "../modules/ProjectSetup/redux/constants";
import * as materialTemplatesSagas from "../modules/materialTemplates/redux/sagas/handleTemplates";
import * as materialTemplatesConstants from "../modules/materialTemplates/redux/constants";

import * as projects from "../modules/Projects/redux/sagas/projectSagas";
import * as projectsConstants from "../modules/Projects/redux/constants";
import * as projectDocRevisionsSagas from "../modules/Projects/tableSection/revisions/redux/sagas/projectRevisionsSagas";
import * as projectDocRevisionsConstants from "../modules/Projects/tableSection/revisions/redux/constants";
import * as projectDocDistributionSagas from "../modules/Projects/tableSection/distributionTable/redux/sagas/projectDistributionSagas";
import * as projectDocDistributionConstants from "../modules/Projects/tableSection/distributionTable/redux/constants";
import deliveryNotesSaga from "../modules/DeliveryNoteRegister/redux/sagas";
import * as deliveryNotesConstants from "../modules/DeliveryNoteRegister/redux/constants";

function* watcherSaga() {
    yield takeEvery(authConstants.LOGIN, authSagas.handleLoginUser);
    yield takeEvery(authConstants.LOGOUT, authSagas.handleLogoutUser);
    // yield takeLatest(
    //     constants.FETCH_USERS_UTIL_DATA,
    //     usersManager.handleFetchUserDetailsUtils
    //   );
    yield takeLatest(constants.FETCH_USER, usersManager.handleFetchUser);
    yield takeLatest(constants.FETCH_ALL_USERS, usersManager.handleFetchAllUsers);
    yield takeLatest(constants.DELETE_USER, usersManager.handleDeleteUser);
    yield takeLatest(constants.UPDATE_USER, usersManager.handleUpdateUser);
    yield takeLatest(constants.UPDATE_USER_PERMISSIONS, usersManager.handleUpdateUserPermissions);
    yield takeLatest(constants.UPDATE_USER_SETTINGS, usersManager.handleUpdateUserSettings);
    yield takeLatest(constants.CREATE_USER, usersManager.handleCreateUser);
    yield takeLatest(constants.CREATE_USER_PROJECT, usersManager.handleCreateUserProject);
    yield takeLatest(constants.UPDATE_USER_PROJECT, usersManager.handleUpdateUserProject);
    yield takeLatest(constants.DELETE_USER_PROJECT, usersManager.handleDeleteUserProject);
    yield takeLatest(constants.SEND_DETAILS_TO_USER, usersManager.handleSendDetailsToUser);
    yield takeLatest(
        departmentsConstants.FETCH_DEPARTMENTS,
        departments.handleFetchDepartments
      );
      yield takeEvery(
        departmentsConstants.UPDATE_DEPARTMENTS,
        departments.handleUpdateDepartment
      );
      yield takeEvery(
        departmentsConstants.DELETE_DEPARTMENTS,
        departments.handleDeleteDepartments
      );
      yield takeEvery(
        departmentsConstants.CREATE_DEPARTMENTS,
        departments.handleCreateDepartment
      );
      yield takeLatest(
        prodStatusesConstants.FETCH_PROJECT_STATUSES,
        prodStatuses.handleFetchProjectStatuses
      );
      yield takeLatest(
        prodStatusesConstants.UPDATE_PROJECT_STATUSES,
        prodStatuses.handleUpdateProjectStatuses
      );
      yield takeLatest(
        prodStatusesConstants.DELETE_PROJECT_STATUSES,
        prodStatuses.handleDeleteProjectStatuses
      );
      yield takeLatest(
        prodStatusesConstants.CREATE_PROJECT_STATUSES,
        prodStatuses.handleCreateProjectStatuses
      );
    
      yield takeLatest(
        prodStatusesConstants.UPDATE_ORDER,
        prodStatuses.handleUpdateProjectOrder
      );
      yield takeLatest(
        commodityConstants.FETCH_COMMODITIES,
        commodity.handleFetchCommodities
      );
      yield takeLatest(
        commodityConstants.UPDATE_COMMODITIES,
        commodity.handleUpdateCommodity
      );
      yield takeLatest(
        commodityConstants.DELETE_COMMODITIES,
        commodity.handleDeleteCommodity
      );
      yield takeLatest(
        commodityConstants.CREATE_COMMODITIES,
        commodity.handleCreateCommodity
      );
      yield takeLatest(
        supplierConstants.FETCH_SUPPLIERS,
        supplier.handleFetchSuppliers
      );
      yield takeLatest(
        supplierConstants.UPDATE_SUPPLIERS,
        supplier.handleUpdateSupplier
      );
      yield takeLatest(
        supplierConstants.DELETE_SUPPLIERS,
        supplier.handleDeleteSupplier
      );
      yield takeLatest(
        supplierConstants.CREATE_SUPPLIERS,
        supplier.handleCreateSupplier
      );
      yield takeLatest(
        materialTypesConstants.FETCH_MATERIAL_TYPES,
        materialTypes.handleFetchMaterialTypes
      );
      yield takeLatest(
        materialTypesConstants.FETCH_BOLT_TYPES,
        materialTypes.handleFetchBoltTypes
      );
      yield takeLatest(
        materialTypesConstants.UPDATE_MATERIAL_TYPES,
        materialTypes.handleUpdateMaterialTypes
      );
      yield takeLatest(
        materialTypesConstants.DELETE_MATERIAL_TYPES,
        materialTypes.handleDeleteMaterialTypes
      );
      yield takeLatest(
        materialTypesConstants.CREATE_MATERIAL_TYPES,
        materialTypes.handleCreateMaterialTypes
      );
      yield takeLatest(
        materialTypesConstants.UPDATE_MATERIAL_TYPES_ORDER,
        materialTypes.handleUpdateMaterialTypesOrder
      );
      // Location Management Sagas
      yield takeLatest(
        locationConstants.FETCH_LOCATION,
        locationSagas.handleFetchLocations
      );
      yield takeLatest(
        locationConstants.FETCH_ALL_LOCATIONS,
        locationSagas.handleFetchAllLocations
      );
      yield takeLatest(
        locationConstants.CREATE_LOCATION,
        locationSagas.handleCreateLocation
      );
      yield takeLatest(
        locationConstants.UPDATE_LOCATION,
        locationSagas.handleUpdateLocation
      );
      yield takeLatest(
        locationConstants.DELETE_LOCATION,
        locationSagas.handleDeleteLocation
      );
      yield takeLatest(
        projectSetupConstants.FETCH_ALL_PROJECTS,
        projectSetupSagas.handleFetchAllProjects
      );
      yield takeLatest(
        projectSetupConstants.UPDATE_PROJECT,
        projectSetupSagas.handleUpdateProject
      );
      yield takeLatest(
        projectSetupConstants.DELETE_PROJECT,
        projectSetupSagas.handleDeleteProject
      );
      yield takeLatest(
        projectSetupConstants.CREATE_PROJECT,
        projectSetupSagas.handleCreateProject
      );
      yield takeLatest(
        projectSetupConstants.FETCH_PROJECT,
        projectSetupSagas.handleFetchProject
      );
      yield takeLatest(
        projectSetupConstants.DELETE_PROJECT_ATTACH,
        projectSetupSagas.handleDeleteProjectAttach
      );
      // yield takeLatest(
      //   projectSetupConstants.UPDATE_PROJECT_NOTIFICATIONS,
      //   projectSetupSagas.handleUpdateProjectNotifications
      // );
      
      // Project Priority API saga handlers
      yield takeLatest(
        projectSetupConstants.FETCH_PROJECT_PRIORITIES,
        projectSetupSagas.handleFetchProjectPriorities
      );
      yield takeLatest(
        projectSetupConstants.CREATE_PROJECT_PRIORITY,
        projectSetupSagas.handleCreateProjectPriority
      );
      yield takeLatest(
        projectSetupConstants.UPDATE_PROJECT_PRIORITY,
        projectSetupSagas.handleUpdateProjectPriority
      );
      yield takeLatest(
        projectSetupConstants.DELETE_PROJECT_PRIORITY,
        projectSetupSagas.handleDeleteProjectPriority
      );
      yield takeLatest(
        projectSetupConstants.SORT_PROJECT_PRIORITIES,
        projectSetupSagas.handleSortProjectPriorities
      );
      yield takeLatest(
        materialTemplatesConstants.FETCH_ALL_TEMPLATES,
        materialTemplatesSagas.handleFetchAllTemplates
      );
      yield takeLatest(
        constants.FETCH_ALL_USER_PROJECTS,
        usersManager.handleFetchAllUserProjects
      );
      yield takeLatest(
        materialTemplatesConstants.FETCH_TEMPLATE,
        materialTemplatesSagas.handleFetchTemplate
      );
      yield takeLatest(
        materialTemplatesConstants.CREATE_TEMPLATE,
        materialTemplatesSagas.handleCreateTemplate
      );
      yield takeLatest(
        materialTemplatesConstants.UPDATE_TEMPLATE,
        materialTemplatesSagas.handleUpdateTemplates
      );
      yield takeLatest(
        materialTemplatesConstants.DELETE_TEMPLATE,
        materialTemplatesSagas.handleDeleteTemplate
      );
      yield takeEvery(
        authConstants.FETCH_SIDEBAR_PROJECTS,
        authSagas.handleFetchSidebarProjects
      );

      // Projects Sagas
      yield takeLatest(
        projectsConstants.FETCH_MATERIAL_CONTROL,
        projects.handleFetchMaterialControl
      );
      yield takeLatest(
        projectsConstants.DELETE_MATERIAL_CONTROL,
        projects.handleDeleteMaterialControl
      );
      yield takeLatest(
        projectsConstants.MARK_ITEM_AS_RECEIVED,
        projects.handleMarkItemAsReceived
      );
      yield takeLatest(
        projectsConstants.MARK_ITEM_AS_COMPLETED,
        projects.handleMarkItemAsCompleted
      );
      yield takeLatest(
        projectsConstants.MARK_ITEM_AS_RECEIVED_UPDATE,
        projects.handleMarkItemAsReceivedUpdate
      );
      yield takeLatest(
        projectsConstants.FETCH_PROJECT_COMPLETION_DATA,
        projects.handleFetchProjectCompletionData
      );
      // Projects Sagas
      // Project CRUD operations are not available in the constants
      
      // Project Distribution Sagas
      yield takeLatest(
        projectDocDistributionConstants.FETCH_PROJECT_DISTRIBUTION, 
        projectDocDistributionSagas.handleFetchProjectDistribution
      );
      yield takeLatest(
        projectDocDistributionConstants.CREATE_PROJECT_DISTRIBUTION, 
        projectDocDistributionSagas.handleCreateProjectDistribution
      );
      yield takeLatest(
        projectDocDistributionConstants.UPDATE_PROJECT_DISTRIBUTION, 
        projectDocDistributionSagas.handleUpdateProjectDistribution
      );
      yield takeLatest(
        projectDocDistributionConstants.DELETE_PROJECT_DISTRIBUTION, 
        projectDocDistributionSagas.handleDeleteProjectDistribution
      );
      yield takeLatest(
        projectDocDistributionConstants.DELETE_PROJECT_DISTRIBUTION_ATTACH, 
        projectDocDistributionSagas.handleDeleteProjectDistributionAttach
      );
      yield takeLatest(
        projectDocDistributionConstants.ADD_PROJECT_DISTRIBUTION_ATTACH, 
        projectDocDistributionSagas.handleAddProjectDistributionAttach
      );
      
      // Project Revisions Sagas
      yield takeLatest(
        projectDocRevisionsConstants.FETCH_PROJECT_REVISIONS, 
        projectDocRevisionsSagas.handleFetchProjectRevisions
      );
      yield takeLatest(
        projectDocRevisionsConstants.CREATE_PROJECT_REVISIONS, 
        projectDocRevisionsSagas.handleCreateProjectRevision
      );
      yield takeLatest(
        projectDocRevisionsConstants.UPDATE_PROJECT_REVISIONS, 
        projectDocRevisionsSagas.handleUpdateProjectRevision
      );
      yield takeLatest(
        projectDocRevisionsConstants.DELETE_PROJECT_REVISIONS, 
        projectDocRevisionsSagas.handleDeleteProjectRevision
      );
      yield takeLatest(
        projectDocRevisionsConstants.DELETE_PROJECT_REVISIONS_ATTACH, 
        projectDocRevisionsSagas.handleDeleteProjectRevisionAttach
      );
      yield takeLatest(
        projectDocRevisionsConstants.ADD_PROJECT_REVISIONS_ATTACH, 
        projectDocRevisionsSagas.handleAddProjectRevisionAttach
      );

      yield takeLatest(
        projectsConstants.CREATE_MATERIAL_CONTROL,
        projects.handleCreateMaterialControl
      );

      yield takeLatest(
        projectsConstants.UPDATE_MATERIAL_CONTROL,
        projects.handleUpdateMaterialControl
      );

}


export function* rootSaga() {
  yield all([watcherSaga(), deliveryNotesSaga()]);
}